export default "<!--component html goes here -->\r\n<app-cards [isLocal]=\"true\"></app-cards>\r\n";